import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useIsFullscreen } from "../../../VideoContextProvider/context/state/isFullscreen.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { FullScreenIcon } from "./FullScreenIcon/index.js";
import { ExitFullScreenIcon } from "./ExitFullScreenIcon/index.js";
import { stub } from "@nbcnews/analytics-framework";
if (stub !== void 0) {
  stub("register", "sigma_video_fullscreen_click");
}
const FullScreenButton = ({ onFullScreenRequest }) => {
  const { t } = useTranslation();
  const videoController = useVideoController();
  const isFullscreen = useIsFullscreen();
  const handleClick = () => {
    if (onFullScreenRequest) {
      onFullScreenRequest();
      stub("track", "sigma_video_fullscreen_click", { fullscreen: "bypass" });
    } else {
      videoController.toggleFullscreen();
      stub("track", "sigma_video_fullscreen_click", { fullscreen: true });
    }
  };
  return /* @__PURE__ */jsx(
    "button",
    {
      type: "button",
      className: "omega_btnFullScreen",
      "data-test": "video-toggle-fullscreen",
      "data-testid": "video-toggle-fullscreen",
      "aria-label": isFullscreen ? t("Exit full screen") : t("Full screen"),
      onClick: handleClick,
      children: isFullscreen ? /* @__PURE__ */jsx(ExitFullScreenIcon, {}) : /* @__PURE__ */jsx(FullScreenIcon, {})
    },
    "toggleFullscreen"
  );
};
export {
  FullScreenButton };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/FullScreenButton/index.js.map